import { render, staticRenderFns } from "./TopSpenderPanel.vue?vue&type=template&id=21119c6c&scoped=true"
import script from "./TopSpenderPanel.vue?vue&type=script&lang=js"
export * from "./TopSpenderPanel.vue?vue&type=script&lang=js"
import style0 from "./TopSpenderPanel.vue?vue&type=style&index=0&id=21119c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21119c6c",
  null
  
)

export default component.exports